module.exports = __webpack_public_path__ + "img/深框.c799a129.png";